import React, {PureComponent} from "react";
import {ProgressionLevelEntity} from "../../data/entities/ProgressionLevelEntity";
import ProgressionLevelMilestone from "./ProgressionLevelMilestone";
import {UserProgressionInfoEntity} from "../../data/entities/UserProgressionInfoEntity";
import classNames from 'classnames';

interface Props {
    progressionLevels: ProgressionLevelEntity[];
    userProgressionInfo: UserProgressionInfoEntity;
}

export default class ProgressionLevelProgressBar extends PureComponent<Props> {

    render(): JSX.Element {

        let {progressionLevels, userProgressionInfo} = this.props;
        let {currentProgressionLevel} = userProgressionInfo;
        let {consecutiveActiveMonths} = userProgressionInfo.subscriptionInfo;
        let identifiedProgressionLevel = false;

        progressionLevels.forEach((progressionLevel: ProgressionLevelEntity, index: number) => {
            progressionLevel.isLast = (index === progressionLevels.length-1);
            if (!identifiedProgressionLevel && currentProgressionLevel) {
                progressionLevel.userProgress = 80;
            } else {
                progressionLevel.userProgress = 0;
            }
            if (currentProgressionLevel && progressionLevel.id === currentProgressionLevel.id) {
                progressionLevel.userProgress = (currentProgressionLevel.progression) ? currentProgressionLevel.progression : 0;
                identifiedProgressionLevel = true;
            }
            progressionLevel.monthsRemaining = (progressionLevel.ruleSubscriptionMonths - consecutiveActiveMonths > 0)
                ? (progressionLevel.ruleSubscriptionMonths - consecutiveActiveMonths) : 0;
        });

        let progressBarBgClasses = classNames({
            "progressBarBg": true,
            "complete": consecutiveActiveMonths > progressionLevels[progressionLevels.length-1].ruleSubscriptionMonths
        });

        return (
            <React.Fragment>
                <div className="progressionLevelsProgressBar">
                    {progressionLevels.length > 0 && progressionLevels.map((progressionLevel: ProgressionLevelEntity, index) => {
                        if (progressionLevel.image) {
                            return (
                                <ProgressionLevelMilestone
                                    progressionLevel={progressionLevel}
                                    previousProgressionLevel={index > 0 ? progressionLevels[index - 1] : null}
                                    totalMonths={progressionLevels[progressionLevels.length - 1].ruleSubscriptionMonths}
                                    consecutiveActiveMonths={consecutiveActiveMonths}
                                    index={index}
                                    key={index}
                                />
                            )
                        }

                        return null;
                    })}
                    <div className="progressBarSeparator platinum-level">
                        <div className={progressBarBgClasses}></div>
                    </div>
                    <div className="progressBarSeparator infinity">
                        <div className={progressBarBgClasses}></div>
                    </div>
                    <div className="progressBarSeparator infinity">
                        <div className={progressBarBgClasses}></div>
                    </div>
                    <div className="progressBarSeparator infinity">
                        <div className={progressBarBgClasses}></div>
                    </div>
                </div>
            </React.Fragment>

        );
    }
}